import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "embed-responsive" };
const _hoisted_2 = {
    key: 0,
    class: "w-100 h-100"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
    class: "h-100 w-100 bg-dark opacity-50 text-white position-relative d-flex justify-content-center align-items-center",
    style: { "z-index": "10" }
};
const _hoisted_5 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.mode === 'thumbnail')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_ctx.mode === 'thumbnail')
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.thumbSource,
                        class: "gallery-image position-absolute video__thumbnail"
                    }, null, 8, _hoisted_3))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_g_icon, {
                        width: "30",
                        height: "30",
                        class: "text-white opacity-100",
                        src: "/assets/icons/play-circle.svg"
                    })
                ])
            ]))
            : (_openBlock(), _createElementBlock("iframe", {
                key: 1,
                src: _ctx.videoSource,
                class: "w-100 h-100",
                allow: "autoplay; fullscreen",
                allowfullscreen: ""
            }, null, 8, _hoisted_5))
    ]));
}
